import { groq } from 'next-sanity'

// Talent story (Sanity _type: story) queries
export const talentStoriesQuery = groq`
    *[_type == "story" && isPublished == true] | order(publishedAt desc) {
    _id,
    name,
    slug,
    position,
    company,
    quote,
    body,
    photo,
    isPublished,
    publishedAt
  }
`

export const talentStoryBySlugQuery = groq`
  *[_type == "story" && slug.current == $slug][0] {
    _id,
    name,
    slug,
    position,
    company,
    quote,
    body,
    photo,
    isPublished,
    publishedAt
  }
`

// Team member queries
export const teamMembersQuery = groq`
  *[_type == "teamMember" && isActive == true && isBoardMember == false] | order(order asc, name asc) {
    _id,
    name,
    role,
    bio,
    photo,
    linkedin,
    order
  }
`

export const boardMembersQuery = groq`
  *[_type == "teamMember" && isActive == true && isBoardMember == true] | order(order asc, name asc) {
    _id,
    name,
    role,
    bio,
    photo,
    linkedin,
    isBoardMember,
    order
  }
`

// Partner queries
export const partnersQuery = groq`
  *[_type == "partner" && isActive == true] | order(order asc, name asc) {
    _id,
    name,
    logo,
    website,
    description,
    partnerType,
    featured,
    order
  }
`

export const partnersByTypeQuery = groq`
  *[_type == "partner" && isActive == true && partnerType == $type] | order(order asc, name asc) {
    _id,
    name,
    logo,
    website,
    description,
    partnerType,
    featured,
    order
  }
`

// FAQ queries
export const faqsQuery = groq`
  *[_type == "faq" && isPublished == true] | order(category asc, order asc) {
    _id,
    question,
    answer,
    category,
    featured,
    order,
    isPublished
  }
`

export const faqsByCategoryQuery = groq`
  *[_type == "faq" && isPublished == true && category == $category] | order(order asc) {
    _id,
    question,
    answer,
    category,
    featured,
    order,
    isPublished
  }
`

// Impact card queries
export const impactCardsQuery = groq`
  *[_type == "impact" && isActive == true] | order(order asc) {
    _id,
    title,
    subtitle,
    icon,
    suffix,
    order,
    isActive
  }
`

// Press article queries
export const pressArticlesQuery = groq`
  *[_type == "press" && isActive == true] | order(order asc) {
    _id,
    publication,
    articleTitle,
    articleUrl,
    image,
    publishedDate,
    order,
    isActive
  }
`

// Client story queries (body: expand image blocks for urlFor + Next/Image)
const clientStoryBodyProjection = groq`body[]{
  ...,
  _type == "image" => {
    ...,
    asset->
  }
}`

export const clientStoriesQuery = groq`
  *[_type == "clientStory" && isPublished == true] | order(publishedAt desc) {
    _id,
    companyName,
    slug,
    title,
    summary,
    ${clientStoryBodyProjection},
    companyLogo,
    coverImage,
    isPublished,
    publishedAt
  }
`

export const clientStoryBySlugQuery = groq`
  *[_type == "clientStory" && slug.current == $slug][0] {
    _id,
    companyName,
    slug,
    title,
    summary,
    ${clientStoryBodyProjection},
    companyLogo,
    coverImage,
    isPublished,
    publishedAt
  }
`
